import autobind from "autobind-decorator";
import Suffix from "./Suffix";

export default class SpecialQuantity {
  constructor(container) {
    if (!container) return;
    this.container = container;

    this.container
      .closest("form")
      .addEventListener(
        "Product.itemNumber.change",
        this.productItemNumberChange,
      );
    this.container
      .closest("form")
      .addEventListener("Product.quantity.change", this.productQuantityChange);
  }

  get minMustContainer() {
    let minMustBuyContainer = this.container.querySelector(".min-must-text");

    if (!minMustBuyContainer) {
      minMustBuyContainer = document.createElement("p");
      minMustBuyContainer.classList.add("min-must-text");
      this.container.insertBefore(minMustBuyContainer, this.addToCartInput);
    }

    return minMustBuyContainer;
  }

  get minMustText() {
    const ending = "due to manufacturer packaging.";
    if (
      this.product.minimumQuantity > 1 &&
      this.product.divisor > 1 &&
      this.product.minimumQuantity > this.product.divisor
    ) {
      return `You must buy a minimum of ${this.product.minimumQuantity}
      and in additional increments of ${this.product.divisor} ${ending}`;
    }

    if (this.product.divisor > 1) {
      return `You must buy in increments of ${this.product.divisor} ${ending}`;
    }

    if (this.product.minimumQuantity > 1) {
      return `You must buy a minimum of ${this.product.minimumQuantity} at a time ${ending}`;
    }

    return "";
  }

  get addToCartInput() {
    return this.container.querySelector("[data-action=addToCart]");
  }

  get formGroup() {
    return this.container.querySelector(".form__group");
  }

  get select() {
    return (
      this.container.querySelector("select") ||
      this.container.insertBefore(
        document.createElement("select"),
        this.minMustContainer,
      )
    );
  }

  @autobind
  productQuantityChange(event) {
    const noSelection = this.container.querySelector(".no-selection");
    const spclQtyNoSelection = this.formGroup?.querySelector(".no-selection");
    this.product = event.detail;

    if (noSelection) noSelection.classList.remove("no-selection");
    if (spclQtyNoSelection) spclQtyNoSelection.classList.remove("no-selection");

    if (this.product.specialQuantity && this.product.otherQuantitySelected) {
      this.hideSelect();
    }
  }

  hideSelect() {
    this.select.hidden = true;
    if (this.formGroup) this.formGroup.hidden = true;
    this.container.hidden = false;
    this.addToCartInput.hidden = true;
    this.select.name = "";
  }

  @autobind
  productItemNumberChange(event) {
    const noSelection = this.container.querySelector(".no-selection");
    this.product = event.detail;
    this.select.value = "0";

    if (
      this.product.specialQuantity &&
      !this.product.otherQuantitySelected &&
      this.product.available
    ) {
      if (noSelection) noSelection.classList.remove("no-selection");
      this.hide();
      return this.render();
    }

    return this.hide();
  }

  hide() {
    const formActive = this.container.querySelector(".form--active");
    this.container.hidden = true;
    this.select.name = "";

    if (formActive) formActive.remove();
  }

  render() {
    this.container.hidden = false;
    this.select.hidden = false;
    this.addToCartInput.hidden = false;

    const item = Suffix.priceLookup(this.product.itemNumber);

    if (!item) return;

    const selectForm = document.createElement("div");
    const selectGroup = document.createElement("div");
    const selectContainer = document.createElement("div");
    const selectLabel = document.createElement("label");
    const selectLabelText = document.createElement("span");
    const selectIcon = document.createElement("i");

    this.container.prepend(selectForm);
    selectForm.prepend(selectGroup);
    selectGroup.prepend(selectContainer);
    selectContainer.append(selectLabel);
    selectContainer.append(selectIcon);
    selectLabel.append(selectLabelText);

    selectForm.className += "form form--active";
    selectGroup.classList.add("form__group");
    selectContainer.className += "form__control-container no-selection";
    selectLabel.classList.add("form__label");
    selectLabelText.classList.add("form__label-text");
    selectIcon.className +=
      "icon-down-micro form__control-icon form__control-icon--lg";

    this.minMustContainer.textContent = this.minMustText;

    this.select.name = "qty";

    const selectClasses = ["configure", "qty-preset-select", "form__control"];
    selectClasses.forEach((className) => {
      this.select.classList.add(className);
    });

    let tempItemQuantityText = "Quantity";
    if (window.itemQuantityText) {
      tempItemQuantityText = window.itemQuantityText;
    }

    this.select.innerHTML = `<option disabled selected value="0">Select ${tempItemQuantityText} </option> ${item.drop_down_select}`;

    selectLabelText.innerHTML = `${tempItemQuantityText}`;
    selectContainer.prepend(this.select);
  }
}
